/* Osma theme — minimal interactions
   Drop into Dawn theme: /assets/osma.js
   Loaded via theme.liquid: <script src="{{ 'osma.js' | asset_url }}" defer></script>
*/

(function () {
  // Subscription radio toggle (visual only — Shopify Subscriptions handles the cart logic)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'osma-purchase-option') {
      var options = document.querySelectorAll('.osma-sub-option');
      options.forEach(function (opt) {
        var input = opt.querySelector('input[type="radio"]');
        if (input && input.checked) {
          opt.style.borderColor = 'var(--osma-accent)';
        } else {
          opt.style.borderColor = 'var(--osma-line)';
        }
      });
    }
  });

  // Sticky CTA — show after hero scrolled past on mobile
  var stickyCta = document.querySelector('.osma-sticky-cta');
  if (stickyCta) {
    var hero = document.querySelector('.osma-hero');
    var heroHeight = hero ? hero.offsetHeight : 600;
    window.addEventListener('scroll', function () {
      if (window.scrollY > heroHeight * 0.6) {
        stickyCta.style.transform = 'translateY(0)';
        stickyCta.style.opacity = '1';
      } else {
        stickyCta.style.transform = 'translateY(100%)';
        stickyCta.style.opacity = '0';
      }
    }, { passive: true });
  }

  // Smooth scroll for anchor links
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (link) {
      var id = link.getAttribute('href');
      if (id.length > 1) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  });
})();
